<div class="align-items-center">
    @if(!roleStarted){
        <div class="col-12 mb-3 p-0">
            The client has been informed that you are not able to work on project <b>{{roleEndedInfo?.project?.codeName}}</b> Role <b>{{roleEndedInfo?.role?.roleType}}</b>. You will now be eligible to receive new offers.
        </div>
    }

    @if(roleStarted && !hasTsheet){
        <div class="col-12 mb-3 p-0">
            <p>Your position on <b>{{roleEndedInfo?.project?.codeName}}</b>, <b>{{roleEndedInfo?.role?.roleType}}</b> has ended. Thank you for your efforts. Please verify your time records and rate your experience on the project.</p>
        </div>
    }

    @if(roleStarted && hasTsheet){
        <div class="col-12 mb-3 p-0">
            <p>Your position on <b>{{roleEndedInfo?.project?.codeName}}</b>, <b>{{roleEndedInfo?.role?.roleType}}</b> has ended. Thank you for your efforts. Please verify your time records and rate your experience on the project.</p>
        </div>
        <div class="col-12 mb-3 p-0">
            <p>Do you certify that your time records are accurate?</p>
        </div>
    }

    @if(roleStarted && hasTsheet){
        <div class="flex justify-content-end gap-2">
            <p-button [label]="gotoInvoiceText" (click)="confirm(false)" />
            <p-button label="yes" (click)="confirm(true)" />
        </div>
    }

    @if(!roleStarted || !hasTsheet){
        <div class="flex justify-content-end gap-2">
            <p-button label="ok" (click)="confirm(true)" />
        </div>
    }
    
</div>
